import { useLayoutEffect } from 'react';
import { DATA_QA_FIXED_OUTER_CONTAINER } from '../constants';

export const useAddBodyPadding = (isSet: boolean, isMobile: boolean) => {
  useLayoutEffect(() => {
    if (!isMobile || isSet) return;

    const fixedContainer = document.querySelector(`[data-qa=${DATA_QA_FIXED_OUTER_CONTAINER}]`);

    if (!fixedContainer) return;

    const extraHeight = fixedContainer.getBoundingClientRect().height;
    const originalPadding = window.getComputedStyle(document.body).paddingBottom;
    const originalValue = parseFloat(originalPadding) || 0;

    document.body.style.paddingBottom = `${originalValue + extraHeight}px`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
